export const REGEX_ALFANUMERICO_ESPACO_PONTO = /^[a-zA-Zà-úÀ-Ú0-9\s.]*$/;
